import { createContext, useContext } from '@wordpress/element';
export const CompositeContext = createContext({});
CompositeContext.displayName = 'CompositeContext';
export const useCompositeContext = () => useContext(CompositeContext);
export const CompositeGroupContext = createContext(false);
CompositeGroupContext.displayName = 'CompositeGroupContext';
export const useCompositeGroupContext = () => useContext(CompositeGroupContext);